import {useProductStore} from "@domains/settings/stores/product.store";

export const getCurrentProductResolver = async (): Promise<void> => {

    const productStore = useProductStore();

    await productStore.getCurrentProduct()
};
